import React, { useEffect, Fragment } from "react";
import "./index.scss";
import afterLoginApi from "../../Util/API Calls/afterLogin";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

export default function KnowledgeCenter() {
  useEffect(() => {
    afterLoginApi
      .post(
        "/doctor/get-my-profile",
        {},
        {
          headers: {
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        C2CConsole.log(response);
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  }, []);

  return <Fragment></Fragment>;
}
